import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  reviewRequestStatistics: [],
  pageSize: storage.session.getItem(types.SESSION_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.SESSION_DAYS) || 0,
  searchTerm: storage.session.getItem(types.SESSION_SEARCH_TERM) || '',
  status: storage.session.getItem(types.SESSION_STATUS) || 'SUBMITTED'
})



// WEBPACK FOOTER //
// ./src/store/modules/review-requests/state.js